import _ from '../../core/utils'
import SLIDER_CARDS_CONFIG from "./config"
import Flickity from 'flickity'

class SliderCardsClass {
    constructor( slider ) {
        this.DOM = {
            slider: slider,
            wrap: _.select( '.fl__slider-wrap', slider),
            slides: _.selectAll( '.slide', slider ),
            controls: {
                prev: _.select( '.fl__slider-control--prev', slider ),
                next: _.select( '.fl__slider-control--next', slider )
            }
        }

        this.groupCells = 2
        this.flckty = null
        this.slidesLength = this.DOM.slides.lenght

        this.init()
    }

    init() {
        this._groupCells()
        this._slider()
    }

    _listeners() {
        this.DOM.controls.prev.addEventListener( 'click', this._controls.bind( this ) )
        this.DOM.controls.next.addEventListener( 'click', this._controls.bind( this ) )
    }

    _groupCells() {
        window.innerWidth <= 768 ? this.groupCells = 1 : null
    }

    _slider() {
        this.flckty = new Flickity( this.DOM.wrap, {
            pageDots: true,
            prevNextButtons: false,
            contain: true,
            wrapAround: false,
            cellAlign: 'left',
            groupCells: this.groupCells,
            on: {
                ready: () => {
                    this._listeners()
                },
                change: ( index ) => {
                    this._controlsVisibility( index )
                    console.log( `Index: ${index}`)
                    console.log( `Length: ${this.DOM.slides.length / this.groupCells}`)
                }
            }
        })
    }

    _controls() {
        let action = event.currentTarget.getAttribute( 'data-action' )
        action === 'next' ? this.flckty.next() : this.flckty.previous()
    }

    _controlsVisibility( index ) {
        if ( index === 0 ) {
            _.removeClass( this.DOM.controls.prev, 'is--visible' )
        } else if ( index === ( this.DOM.slides.length / this.groupCells ) - 1 ) {
            _.removeClass( this.DOM.controls.next, 'is--visible' )
        } else {
            _.addClass( this.DOM.controls.prev, 'is--visible' )
            _.addClass( this.DOM.controls.next, 'is--visible' )
        }
    }

    
}

const SLIDERS_CARDS = []
SLIDER_CARDS_CONFIG.sliders.forEach( ( slider ) => {
    SLIDERS_CARDS.push( new SliderCardsClass( slider ) )
})